// extracted by mini-css-extract-plugin
export default {"img__container":"QuestionFive_img__container__hSLLe","label":"QuestionFive_label__P0oY4","buttonContainer":"QuestionFive_buttonContainer__XXBHe"};